export const DOCUMENT_LIST_CONTAINER = 'document-list';

/** Width from which a document row lays its name, nature, provider and date out in columns. */
export const DOCUMENT_LIST_WIDE_MIN_WIDTH = 720;

export const DOCUMENT_LIST_WIDE_QUERY = `@container ${DOCUMENT_LIST_CONTAINER} (min-width: ${DOCUMENT_LIST_WIDE_MIN_WIDTH}px)`;

export const DOCUMENT_TILE_SIZE = 40;
export const DOCUMENT_TILE_SIZE_WIDE = 32;
